import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

let swiperInstance = null;
let currentMobileState = null;
let originalGroups = null;

function saveOriginalGroups() {
	const wrapper = document.querySelector('.js-gallery-slider .swiper-wrapper');
	if (wrapper && !originalGroups) {
		originalGroups = wrapper.innerHTML;
	}
}

function rebuildSlidesToSingle() {
	const wrapper = document.querySelector('.js-gallery-slider .swiper-wrapper');
	if (!wrapper) return;
	if (!originalGroups) saveOriginalGroups();

	// Получаем все img из исходных групповых слайдов
	// Если оригиналов нет, ищем в текущей разметке (может быть уже перестроено)
	const tempDiv = document.createElement('div');
	tempDiv.innerHTML = originalGroups || wrapper.innerHTML;
	const images = Array.from(tempDiv.querySelectorAll('.gallery-slide-group__item img')).map(img => img.getAttribute('src'));

	wrapper.innerHTML = '';
	images.forEach(src => {
		wrapper.insertAdjacentHTML('beforeend', `
      <div class="swiper-slide gallery__slide">
        <div class="gallery-slide-group__item">
          <img src="${src}" alt="">
        </div>
      </div>
    `);
	});
}

function rebuildSlidesToGroups() {
	const wrapper = document.querySelector('.js-gallery-slider .swiper-wrapper');
	if (!wrapper || !originalGroups) return;
	wrapper.innerHTML = originalGroups;
}

function handleGalleryResponsive() {
	const isMobile = window.innerWidth < 600;
	if (currentMobileState === isMobile) return;

	// Destroy Swiper if exists
	if (swiperInstance) {
		swiperInstance.destroy(true, true);
		swiperInstance = null;
	}

	if (isMobile) {
		rebuildSlidesToSingle();
	} else {
		rebuildSlidesToGroups();
	}

	swiperInstance = new Swiper('.js-gallery-slider', {
		modules: [Navigation],
		slidesPerView: 1,
		loop: true,
		spaceBetween: 24,
		navigation: {
			nextEl: '.gallery__button--next',
			prevEl: '.gallery__button--prev',
		},
	});

	currentMobileState = isMobile;
}

function initGallerySwiper() {
	saveOriginalGroups();
	handleGalleryResponsive();

	// Дебаунсим ресайз для производительности
	let resizeTimeout;
	window.addEventListener('resize', () => {
		clearTimeout(resizeTimeout);
		resizeTimeout = setTimeout(handleGalleryResponsive, 200);
	});
}

export default initGallerySwiper;
